import { render, staticRenderFns } from "./EventsListing.vue?vue&type=template&id=06a2ddce&"
import script from "./EventsListing.vue?vue&type=script&lang=js&"
export * from "./EventsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06a2ddce')) {
      api.createRecord('06a2ddce', component.options)
    } else {
      api.reload('06a2ddce', component.options)
    }
    module.hot.accept("./EventsListing.vue?vue&type=template&id=06a2ddce&", function () {
      api.rerender('06a2ddce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hrmanagement/LeaveManagement/EventsListing.vue"
export default component.exports